export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Oteador.vue?vue&type=template&id=6d63b5be&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Oteador/Oteador.vue?vue&type=template&id=6d63b5be&scoped=true
// module id = 2Rnt
// module chunks = 41